import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export type ProgressSnackbarState = 'loading' | 'success' | 'error';

export interface ProgressSnackbarData {
  state: ProgressSnackbarState;
  title?: string;
  message?: string;
}

/**
 * Rendered directly onto document.body by AsyncNotificationService (not via
 * MatSnackBar): MatSnackBar only keeps one snack bar open at a time and
 * silently dismisses the current one the moment anything else in the app
 * opens a new one, which made this toast disappear early whenever an
 * unrelated snackbar fired during the tracked request.
 */
@Component({
  selector: 'pulpo-progress-snackbar',
  templateUrl: './progress-snackbar.component.html',
  styleUrls: ['./progress-snackbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class ProgressSnackbarComponent {
  data: ProgressSnackbarData = { state: 'loading' };
}
